import AOS from 'aos';
import { UAInfo, EventActions } from './basis.js';

AOS.init();

$(document).on('DOMContentLoaded', () => {
    let ua_info = new UAInfo();
    ua_info.setTabletViewport('1200');
    ua_info.setDeviceClass();

    EventActions.setMediaQueryAction('screen and (max-width: 768px)');
    EventActions.setScrollButtonFade('.pagetop');
    EventActions.setSmoothScroll(500);
    if(ua_info.UA.device.type === 'mobile'){
        EventActions.setCoverAdjust('.cover', '.site_header');
    }

    document.addEventListener('scroll', () => {
        if (window.pageYOffset > document.documentElement.clientHeight / 2) {
            document.querySelector('.site_header').classList.add('fixed');
        } else {
            document.querySelector('.site_header').classList.remove('fixed');
        }
    });

    document.querySelector('.menu_btn').addEventListener('click', () => {
        document.querySelector('.menu_btn').classList.toggle('active');
        document.querySelector('.global_nav').classList.toggle('active');

        let button = document.querySelectorAll('.global_nav a').forEach(item => {
            item.addEventListener('click', () => {
                document.querySelector('.menu_btn').classList.remove('active');
                document.querySelector('.global_nav').classList.remove('active');
            });
        });
    });
});
